import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { ListContainer } from 'components';
import Promoter from './Promoter';
import PromotersTable from './PromotersTable';

const Promoters = () => {
    return (
        <ListContainer>
            <Routes>
                <Route index element={<PromotersTable />} />
                <Route path="create" element={<Promoter />} />
                <Route path="edit/:id" element={<Promoter />} />
                <Route path="*" element={<Navigate to="/promoters" replace />} />
            </Routes>
        </ListContainer>
    );
};

export default Promoters;
